import { render, staticRenderFns } from "./AddressCard.vue?vue&type=template&id=b79b027e&scoped=true&"
import script from "./AddressCard.vue?vue&type=script&lang=js&"
export * from "./AddressCard.vue?vue&type=script&lang=js&"
import style0 from "./AddressCard.vue?vue&type=style&index=0&id=b79b027e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79b027e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardSubtitle,VCardText,VIcon,VTextField})
